import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const QuestionMarkIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('QuestionMarkIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 11.038h.006M6.65 6.313a1.35 1.35 0 1 1 2.486.729C8.733 7.669 8 8.267 8 9.012M14.75 8a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
QuestionMarkIcon.id = 'QuestionMarkIcon';
QuestionMarkIcon.displayName = 'QuestionMarkIcon';
export default QuestionMarkIcon;
